const ARCHIVE_STATUS_DONE = 'done';
const ARCHIVE_STATUS_FILE = 'file';

export const isStreamRecord = (stream) => (
    -1 !== [ARCHIVE_STATUS_DONE, ARCHIVE_STATUS_FILE].indexOf(stream?.archiveStatus?.toLowerCase())
);

export const isStreamStarted = (stream) => (
    stream?.status && stream.status !== 'idle'
    // !!stream?.broadcastSession?.length || (stream?.status && stream.status !== 'idle')
);

export const isStreamLive = (stream) => (
    stream?.broadcastSession?.length > 0
    && !stream.broadcastSession[stream.broadcastSession.length - 1]?.timeStop
);

export const isEpisodeRecorded = (episode) => (
    -1 !== [ARCHIVE_STATUS_DONE, ARCHIVE_STATUS_FILE].indexOf(episode.archiveStatus.toLowerCase())
);
